<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-harry_fox'"
    :addButton="false"
    :addLink="false"
  >
    <v-layout row>
      <v-flex xs12>
        <v-layout row class="thead">
          <v-flex xs4>
            <div class="lbl-title txtov">&nbsp;</div>
          </v-flex>
          <v-flex xs6>
            <div class="lbl-title txtov">&nbsp;</div>
          </v-flex>
          <v-flex xs2>
            <div class="lbl-title txtov text-center">Exclude</div>
          </v-flex>
        </v-layout>
        <v-layout row class="tbody">
          <v-flex xs10>
            <Dropdown2
              class="dbox1"
              :id="'territory_id'"
              :label="'Territory Name'"
              :options="selectedContractDetails.territoriesTV"
              :selected="
                selectedContractDetails.territoriesTV.find(
                  e => e.value == selectedContractDetails.mc.territory_id
                )
              "
              :placeholder="'Territory Name'"
              v-on:selectedChange="e => onDropdownChange('territory_id', e)"
              :bb="'0px'"
            />
          </v-flex>
          <v-flex xs2>
            <div class="lbl-title txtov"></div>
          </v-flex>
        </v-layout>
        <v-layout row class="tbody">
          <v-flex xs10>
            <Dropdown2
              class="dbox1"
              :id="'phy_mechanical_rate_id'"
              :hint="'statutory Rate (leave Empty for Rate of Sale)'"
              :label="'Physical'"
              :options="selectedContractDetails.ratesTV"
              :selected="
                selectedContractDetails.ratesTV.find(
                  e =>
                    e.value == selectedContractDetails.mc.phy_mechanical_rate_id
                )
              "
              :placeholder="'Physical'"
              v-on:selectedChange="
                e => onDropdownChange('phy_mechanical_rate_id', e)
              "
              :bb="'0px'"
            />
          </v-flex>
          <v-flex xs2>
            <div class="dt-checkbox v2 s1">
              <input
                type="checkbox"
                @click="e => onCheckboxChange('phy_exclude', e)"
                :name="'phy_exclude'"
                :id="'phy_exclude'"
                :checked="selectedContractDetails.mc.phy_exclude == '1'"
              />
              <div class="checkmark"></div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row class="tbody">
          <v-flex xs10>
            <Dropdown2
              class="dbox1"
              :id="'bundle_dl_mechanical_rate_id'"
              :hint="'statutory Rate (leave Empty for Rate of Sale)'"
              :label="'Bundle DL'"
              :options="selectedContractDetails.ratesTV"
              :selected="
                selectedContractDetails.ratesTV.find(
                  e =>
                    e.value ==
                    selectedContractDetails.mc.bundle_dl_mechanical_rate_id
                )
              "
              :placeholder="'Bundle DL'"
              v-on:selectedChange="
                e => onDropdownChange('bundle_dl_mechanical_rate_id', e)
              "
              :bb="'0px'"
            />
          </v-flex>
          <v-flex xs2>
            <div class="dt-checkbox v2 s1">
              <input
                type="checkbox"
                @click="e => onCheckboxChange('bundle_dl_exclude', e)"
                :name="'bundle_dl_exclude'"
                :id="'bundle_dl_exclude'"
                :checked="selectedContractDetails.mc.bundle_dl_exclude == '1'"
              />
              <div class="checkmark"></div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row class="tbody">
          <v-flex xs10>
            <Dropdown2
              class="dbox1"
              :id="'track_dl_mechanical_rate_id'"
              :hint="'statutory Rate (leave Empty for Rate of Sale)'"
              :label="'Track DL'"
              :options="selectedContractDetails.ratesTV"
              :selected="
                selectedContractDetails.ratesTV.find(
                  e =>
                    e.value ==
                    selectedContractDetails.mc.track_dl_mechanical_rate_id
                )
              "
              :placeholder="'Track DL'"
              v-on:selectedChange="
                e => onDropdownChange('track_dl_mechanical_rate_id', e)
              "
              :bb="'0px'"
            />
          </v-flex>
          <v-flex xs2>
            <div class="dt-checkbox v2 s1">
              <input
                type="checkbox"
                @click="e => onCheckboxChange('track_dl_exclude', e)"
                :name="'track_dl_exclude'"
                :id="'track_dl_exclude'"
                :checked="selectedContractDetails.mc.track_dl_exclude == '1'"
              />
              <div class="checkmark"></div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";

export default {
  components: {
    DBox
  },
  props: ["selectedContractDetails"],
  computed: {
    contract_id: function() {
      return this.$route.params.contract_id;
    }
  },
  methods: {
    onDropdownChange(name, e) {
      this.$emit("changed", { name, value: e.value });
    },

    onCheckboxChange: function(name, e) {
      const value = e.target.checked ? "1" : "0";
      this.$emit("changed", { name, value });
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-harry_fox {
  --ntable-rowHeight: 32px;
  --row-bottom-border-color: var(--sprt-12);
  --ntable-border-right: var(--sprt-12);

  .thead {
    border-bottom: 1px solid var(--text-secondary);
  }

  .tbody {
    border-bottom: 1px solid var(--sprt-12);
    &.row {
      > .flex {
        border-right: 1px solid var(--sprt-12);
        &:last-child {
          border-right: none;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .row {
    display: flex;
    height: var(--ntable-rowHeight);
  }
  .full-width {
    width: 100%;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .lbl-title {
    padding: 4px 5px;
    color: rgba(70, 70, 70, 0.77);
  }
  .text-center {
    text-align: center;
  }
}
</style>
